import React, { useState, useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { pageContextState } from '../recoil/atoms';
import { PageContext } from '../enums/PageContext.enum';
import { useOnScreen } from './useOnScreen';

export const useShowAddToBag = (productRef: React.RefObject<HTMLElement>): boolean => {
  const pageContext = useRecoilValue(pageContextState);
  const footerRef = useRef(typeof window !== 'undefined' ? document.getElementById('shopify-section-footer-v2') : null);
  const productOnScreen = useOnScreen(productRef, pageContext === PageContext.LandingPage ? '200px' : '0px');
  const footerOnScreen = useOnScreen(footerRef);
  const [showButton, setShowButton] = useState<boolean>(false);

  useEffect(() => {
    setShowButton(!!productOnScreen || !!footerOnScreen);
  }, [productOnScreen, footerOnScreen]);
  return showButton;
};
